module.exports = __webpack_public_path__ + "static/media/no-crossings-icon.beb996f4.svg";